module.exports = __webpack_public_path__ + "static/img/error-bg.38e6355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error-bg.png
// module id = 8D6C
// module chunks = 1